import { render, staticRenderFns } from "./OverviewBase.vue?vue&type=template&id=0232740c"
import script from "./OverviewBase.vue?vue&type=script&lang=ts"
export * from "./OverviewBase.vue?vue&type=script&lang=ts"
import style0 from "./OverviewBase.vue?vue&type=style&index=0&id=0232740c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports